/**
*  AUTHOR : SOHAN
*  WEBSITE :  sca.pearlgreen.com
*  DATE : 20-05-2019
*/

//@MODULE CharitableDonations

define(
   'CharitableDonations.View'
,  [
      'charitable_donations.tpl'
   ,  'Backbone'
   ,  'jQuery'
   ,  'underscore'
   ]
,  function (
      charitable_donations_tpl
   ,  Backbone
   ,  jQuery
   ,  _
   )
{
   'use strict';

   return Backbone.View.extend({

      template: charitable_donations_tpl
   ,  title: _('Charitable Donations').translate()

   ,  events: 
      {
         
      }

   ,  initialize : function()
		{	

		
		}
		
	,	getBreadcrumbPages: function()
		{
			return {
				href:'/Charitable-Donations'
			,	text:'CHARITABLE DONATIONS'
			};
		}

   ,   getContext: function ()
      {
         return {
            
            donors: !_.isEmpty(this.model.attributes) ? _.map(this.model.attributes,function(data){return data;}) : []
         };
      }
   });
});
